<template>
  <div class="page-menu spaceCenter">
    <div class="page-menu-main">
      <el-radio-group v-model="activeKey" @change="menuChange">
        <el-radio-button label="boosting">Stake Boosting</el-radio-button>
        <el-radio-button label="activeValidators">Stake</el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      activeKey: ""
    };
  },
  computed: {},
  methods: {
    menuChange(data) {
      if (data) {
      }
      this.$router.push(`/Stake/${data}`);
    }
  },
  created() {
    this.activeKey = this.$route.name;
  },
  watch: {
    $route(newVal) {
      this.activeKey = this.$route.name;
    }
  }
};
</script>
<style scoped lang="scss">
.page-menu {
  margin-bottom: 0.4rem;

  .page-menu-main {
    // background: ;
    padding: 0.06rem 0.12rem;
    border-radius: 0.06rem;
    border: 1px solid #225bfc;
    font-family: HurmeGeometricSans2-Bold, HurmeGeometricSans2;
  }
  ::v-deep  .el-radio-button--medium {
    .el-radio-button__inner {
      width: 2.72rem;
      font-size: 0.2rem;
      color: #ffffff;
      padding: 0.1rem 0.24rem;
      border-radius: 0.06rem;
      border: none;
      background-color: transparent;
    }
  }
  ::v-deep  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #ffffff;
    font-weight: 500;
    background: #225bfc;
    box-shadow: none;
  }
}
</style>
